import moment from 'moment-timezone'

export function getTimestampDisplay(
  timestamp: moment.MomentInput,
  formatString = 'YYYY-MM-DD hh:mm a',
): string {
  return moment.utc(timestamp).tz(moment.tz.guess()).format(formatString)
}

export function getPostgresDate(date: Date): string {
  return moment(date).format('YYYY-MM-DD')
}
